export default [
//   {
//   path: '/users',
//   redirect: 'users-list'
// },
{
  path: '/users',
  name: 'users',
  component: () => import(/* webpackChunkName: "clients" */ '@/pages/users/UsersPage.vue'),
  meta: { requiresAuth: true }
},
// {
//   path: '/users/list',
//   name: 'users-list',
//   component: () => import(/* webpackChunkName: "users-list" */ '@/pages/users/UsersPage.vue')
// },
{
  path: '/user/edit',
  name: 'users-edit',
  component: () => import(/* webpackChunkName: "users-edit" */ '@/pages/users/EditUserPage.vue'),
  meta: { requiresAuth: true }

},
{
  path: '/perfil',
  name: 'perfil',
  component: () => import(/* webpackChunkName: "perfil" */ '@/pages/users/PerfilPage.vue'),
  meta: { requiresAuth: true }
}]
